import { render, staticRenderFns } from "./AltaTrabajador.vue?vue&type=template&id=77d94f0c&"
import script from "./AltaTrabajador.vue?vue&type=script&lang=js&"
export * from "./AltaTrabajador.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports